module.exports = __webpack_public_path__ + "img/rank-bg.57f37285.svg";